import React from 'react';
import PropTypes from 'prop-types';
import { UiCheckbox, UiIcon } from 'ui-components';
import { translate } from 'utils';

export function FilterCategoryItem(props) {
  const {
    category,
    hasSelectedSubCategory,
    onCategoryChange,
    onCategoryClick,
    showSubCategory,
    disabled,
  } = props;

  const handleCategoryChange = (event, category) => {
    onCategoryChange(event, category);
  };

  const handleCategoryClick = (category) => {
    onCategoryClick(category);
  };

  return (
    <div
      className='category flex between pointer'
      onClick={() => handleCategoryClick(category)}
    >
      <UiCheckbox
        checked={Boolean(hasSelectedSubCategory)}
        name={category}
        onChange={(event) => handleCategoryChange(event, category)}
        onClick={(event) => event.stopPropagation()}
        inputProps={{
          'data-testid': `filter-content-category-${category}-checkbox`,
        }}
        disabled={disabled}
      />
      <span
        className={`flex-1 label ${disabled ? 'disabled' : ''} mb-0`}
        data-testid={`filter-content-category-${category}-label`}
      >
        {translate[category]}
      </span>
      <UiIcon
        icon={`ri-${showSubCategory[category] ? 'subtract' : 'add'}-line`}
        data-testid={`filter-content-category-${category}-icon`}
      />
    </div>
  );
}

FilterCategoryItem.propTypes = {
  category: PropTypes.string,
  hasSelectedSubCategory: PropTypes.bool,
  disabled: PropTypes.bool,
  onCategoryClick: PropTypes.func,
  onCategoryChange: PropTypes.func,
  showSubCategory: PropTypes.object,
};
